var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReportCsv = function SvgReportCsv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-873-881H495V734H-873z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.301 5.753h-5.34V.413a.41.41 0 0 0-.409-.41h-11.5a.41.41 0 0 0-.41.41v11.5c0 .227.184.41.41.41H13.14v6.57H2.053a.412.412 0 0 0-.41.41v3.286c0 .226.183.411.41.411H19.3a.412.412 0 0 0 .412-.41V6.162a.41.41 0 0 0-.412-.41Z",
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.41 11.5h13.142a.41.41 0 0 1 .41.411v7.393a.41.41 0 0 1-.41.413H.411A.412.412 0 0 1 0 19.304V11.91a.41.41 0 0 1 .41-.41Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.27 5.87 13.52.12a.41.41 0 0 0-.702.292v5.75c0 .227.184.41.411.41h5.75a.41.41 0 0 0 .291-.702Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.193 16.15h.74a1.288 1.288 0 0 1-.247.625 1.298 1.298 0 0 1-.493.393 1.544 1.544 0 0 1-.66.146 1.466 1.466 0 0 1-1.137-.474 1.72 1.72 0 0 1-.444-1.23 1.768 1.768 0 0 1 .434-1.234 1.43 1.43 0 0 1 1.104-.484c.425-.01.832.168 1.114.484.174.206.287.456.324.723h-.736a.638.638 0 0 0-.242-.36.775.775 0 0 0-.452-.127.767.767 0 0 0-.611.278c-.16.205-.241.46-.23.72-.012.26.073.515.238.717.151.18.38.283.616.278a.684.684 0 0 0 .682-.455Zm1.377.122h.677a.562.562 0 0 0 .612.445.597.597 0 0 0 .361-.102.328.328 0 0 0 .137-.276.315.315 0 0 0-.227-.32c-.03 0-.166-.039-.41-.122a2.519 2.519 0 0 1-.73-.287.823.823 0 0 1-.338-.698.93.93 0 0 1 .309-.732c.229-.193.523-.292.822-.275.294-.011.584.079.821.255.21.153.334.397.336.656h-.687a.41.41 0 0 0-.464-.318.506.506 0 0 0-.317.09.294.294 0 0 0-.12.242.268.268 0 0 0 .148.255c.165.07.337.119.513.148.228.038.447.116.649.23.266.17.423.468.41.784a.976.976 0 0 1-.464.873 1.424 1.424 0 0 1-.765.185 1.23 1.23 0 0 1-1.077-.465 1.194 1.194 0 0 1-.196-.568Zm4.07.979-1.232-3.285h.735l.801 2.219.687-2.219h.718l-1.088 3.285h-.62Z",
    fill: "#FFF"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportCsv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report-csv.76cec28f.svg";
export { ForwardRef as ReactComponent };